<template>
    <div class="primary" style="height: 42px">
        <v-dialog v-model="dialog" width="1150">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="triggerElement === 'button'"
                    color="primary"
                    v-show="isDisplay"
                    :block="block"
                    :disabled="disabled"
                    :round="round"
                    :depressed="depressed"
                    class="basket-button font-weight-bold my-0 px-0"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon size="18" class="mr-1">restore</v-icon>

                    <template>
                        {{ 'remind product availability' | translation }}
                    </template>
                </v-btn>
                <v-chip
                    v-if="triggerElement === 'chip'"
                    color="secondary"
                    class="reminder_chip"
                    :class="$vuetify.breakpoint.smAndDown ? 'mb-4' : ''"
                    text-color="white"
                    v-show="isDisplay"
                    :block="block"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="reminder_chip_icon">restore</v-icon>

                    <span class="reminder_chip_text ml-1" style="white-space: normal;">
                        {{ 'remind product availability' | translation }}
                    </span>
                </v-chip>
            </template>

            <v-card class="px-3 py-3">
                <v-btn color="secondary mt-0" class="dialog_close_button" fab small @click.stop="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-card-text class="pb-0 py-0 mb-0 mt-0">
                    <span class="dialog_title headline">
                        {{ 'remind product availability' | translation }}
                    </span>
                </v-card-text>

                <v-card-text class="mb-4 pt-2">
                    <span>
                        {{ 'Reminder subscription text' | translation }}
                    </span>
                </v-card-text>

                <v-card-text class="py-0 pb-4">
                    <v-layout>
                        <template>
                            <v-flex v-if="!$vuetify.breakpoint.smAndDown">
                                <v-img
                                    v-if="product.images.product_images[0]"
                                    lazy
                                    ref="image"
                                    :src="product.images.product_images[0]['small']"
                                    class="fill-height mr-4 ml-2"
                                />
                            </v-flex>
                            <v-flex xs12 sm8 py-0 pr-0 class="dialog_fields">
                                <div v-if="$vuetify.breakpoint.smAndDown">
                                    <v-img
                                        v-if="product.images.product_images[0]"
                                        lazy
                                        ref="image"
                                        :src="product.images.product_images[0]['small']"
                                        class="fill-height mr-4 ml-2"
                                    />
                                </div>
                                <div class="mb-2">
                                    <span class="headline">{{ this.product.attributes.de['product.name'] }}</span>
                                </div>
                                <div class="mb-2">
                                    <span class="subheading font-weight-bold">
                                        SKU:
                                    </span>
                                    <span class="subheading text--darken-4" style="color: #666666;">
                                        {{ product.attributes.de['mb.sku'] }}
                                    </span>
                                </div>
                                <div class="black--text font-weight-bold">
                                    <span class="headline font-weight-bold">
                                        {{ 'Gesamt' | translation }} €
                                        {{ priceFormat(this.product.price.price) }}
                                    </span>

                                    <a class="black--text font-weight-bold">
                                        {{ 'inkl.' | translation }}
                                        <span class="text-underline">{{ 'MwSt' | translation }}</span>
                                    </a>
                                </div>
                                <div class="mt-5">
                                    <v-text-field
                                        v-model="email"
                                        :rules="[rules.required, rules.email]"
                                        :label="$language.translate('E-mail-Adresse')"
                                        required
                                        :disabled="disabled"
                                    ></v-text-field>
                                    <v-btn
                                        block
                                        color="primary font-weight-bold ml-0 mb-2"
                                        text
                                        @click="reminderSubscribe()"
                                    >
                                        <span class="x-btn-group-header-text-container-default-framed">
                                            {{ 'remind product availability' | translation }}
                                        </span>
                                    </v-btn>
                                </div>
                            </v-flex>
                        </template>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="reminderSubscribed" width="1150">
            <v-card class="px-2 py-5">
                <v-container class="pr-0 mb-0 mr-0">
                    <v-btn
                        color="secondary"
                        class="dialog_result_close_button"
                        fab
                        small
                        @click.stop="reminderSubscribed = false"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-container>
                <v-container class="fill-height justify-center">
                    <span class="dialog_title headline justify-center">
                        {{ 'Subscription requested.' | translation }}
                    </span>
                </v-container>
                <v-container class="fill-height justify-center">
                    <span class="justify-center">
                        {{ 'You will receive an email as soon as this product is back in stock.' | translation }}
                    </span>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="subscriptionFailed" width="1150">
            <v-card class="px-2 py-5">
                <v-container class="pr-0 mb-0 mr-0">
                    <v-btn
                        color="secondary"
                        class="dialog_result_close_button"
                        fab
                        small
                        @click.stop="subscriptionFailed = false"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-container>
                <v-container class="fill-height justify-center">
                    <span class="dialog_title headline justify-center">
                        {{ 'Subscription to reminder product availability failed.' | translation }}
                    </span>
                </v-container>
                <v-container class="fill-height justify-center">
                    <span class="justify-center">
                        {{ 'Please try again later or contact our support team.' | translation }}
                    </span>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Vue from 'vue';
import gql from 'graphql-tag';

const parentModuleName = 'Product';
const { mapGetters } = createNamespacedHelpers(parentModuleName);

export default {
    data() {
        return {
            dialog: false,
            reminderSubscribed: false,
            subscriptionFailed: false,
            email: null,
            rules: {
                required: value => !!value || 'Dieses Feld wird benötigt und darf nicht leer sein.',
                email: value =>
                    !value ||
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
                    'Bitte geben sie eine gültige Email-Adresse ein.',
            },
        };
    },
    name: 'RemindAvailability',
    props: {
        product: {},
        currentMerchantId: {},
        currentProductId: {},
        triggerElement: String,
        disabled: Boolean,
        round: Boolean,
        depressed: Boolean,
        block: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isDisplay() {
            return !this.isProductBuyable(this.product, this.currentMerchantId, this.currentProductId);
        },
        ...mapGetters(['isProductBuyable']),
    },
    methods: {
        reminderSubscribe() {
            const productExtId = this.product.ext_id;
            const email = this.email;
            this.dialog = false;
            this.subscriptionFailed = false;

            return Vue.$graphql
                .query({
                    query: gql`
                        mutation reminderSubscribe($productExtId: String!, $email: String!) {
                            reminderSubscribe(productExtId: $productExtId, email: $email)
                        }
                    `,
                    variables: {
                        productExtId: productExtId,
                        email: email,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(r => r.data)
                .then(data => {
                    this.reminderSubscribed = true;
                })
                .catch(error => {
                    this.subscriptionFailed = true;

                    console.error(error);
                    return {};
                });
        },
        priceFormat(value) {
            let formatter = new Intl.NumberFormat('de-DE', {
                currency: 'EUR',
                minimumFractionDigits: 2,
            });
            return formatter.format(value);
        },
    },
};
</script>

<style scoped>
.dialog_title {
    color: #fa5f0f;
    font-weight: 600;
}

.dialog_close_button {
    position: relative;
    float: right;
}

.dialog_result_close_button {
    position: absolute;
    right: 0;
    top: 0;
}

.dialog_fields {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.reminder_chip {
    font-size: 12px;
    height: 43px;
    right: 0;
    bottom: 12px;
    position: absolute !important;
    z-index: 1;
    background: transparent linear-gradient(90deg, #343434 0%, #363636 53%, #484848 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 7px 0px 0px 7px;
    margin-right: 0;
}

@media (min-width: 768px) and (max-width: 1265px) {
    .reminder_chip {
        bottom: 17px;
    }
}

@media (max-width: 767px) {
    .reminder_chip {
        bottom: 20px;
    }
}

@media (max-width: 359px) {
    .reminder_chip {
        bottom: 30px;
    }
}

.reminder_chip_text {
    font-size: 12px;
}

.reminder_chip_icon {
    color: #fff;
    size: 24px;
}
</style>
